import { render, staticRenderFns } from "./default-footer-loader.vue?vue&type=template&id=50f3e250"
import script from "./default-footer-loader.vue?vue&type=script&lang=js"
export * from "./default-footer-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports